module.exports = __webpack_public_path__ + "static/img/bi21.d37a552.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/services/assets/bi21.jpg
// module id = kRSa
// module chunks = 0